<template>
  <div class="content">
    <Modal
      v-model="showModal"
      title="关联课程"
      @on-ok="confirm"
      @on-cancel="cancel"
      :loading="$root.$children[0].modalLoading"
      width="1050"
      class="my-modal top"
    >
      <div v-if="canEdit" class="main-panel">
        <div class="search-box gauge_20">
          <div class="btn-item">
            <Button type="primary" @click="openTemplateEdit({})">＋ 新增</Button>
          </div>
        </div>
      </div>
      <p class="total">
        <span> <Checkbox v-if="tableData.length" :disabled="!canEdit" :value="isAll" @on-change="checkAll"> </Checkbox>全部课程</span>
        <span
          >已选择<b>{{ courseIdList.length }}</b
          >项,共<b>{{ tableData.length }}</b
          >款课程</span
        >
      </p>
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :max-height="400" :data="tableData" border @on-selection-change="select">
          <template slot-scope="{ row }" slot="courseId">
            <Checkbox :disabled="!canEdit" :value="isCheck(row.courseId)" @on-change="check(row.courseId)"> </Checkbox>
          </template>
          <template slot-scope="{ row }" slot="articleType">
            <span>{{ articleType[row.articleType] }}</span>
          </template>
        </Table>
      </div>
    </Modal>
    <importCourse ref="importCourse" @sel="sel"></importCourse>
  </div>
</template>
<script>
import importCourse from './importCourse';
export default {
  components: {
    importCourse
  },
  computed: {
    isAll() {
      return this.tableData.length == this.courseIdList.length;
    }
  },
  data() {
    return {
      showModal: false,
      tableLoading: false, //表格loading
      columns: [
        //表格字段
        {
          title: '已关联',
          slot: 'courseId',
          align: 'center',
          width: 100
        },
        {
          title: '课程类型',
          slot: 'articleType',
          align: 'center',
          width: 250
        },
        {
          title: '课程名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '是否上架',
          slot: 'isUse',
          align: 'center',
          width: '180',
          render(h, params) {
            return <span>{params.row.isUse == 0 ? '否' : '是'}</span>;
          }
        }
      ],
      courseIdList: [], //引用课程
      tableData: [], //表格数据
      pageSize: 999, //页容量
      pageNum: 1, //当前页
      search: {},
      articleType: {},
      canEdit: true
    };
  },
  created() {
    try {
      let articleType = JSON.parse(localStorage.getItem('dic'))['TRAIN_ARTICLE_TYPE'];
      this.articleType = articleType;
      for (let key in articleType) {
        this.menuList.push({
          id: key,
          name: articleType[key]
        });
      }
    } catch (e) {
      //TODO handle the exception
    }
  },
  methods: {
    checkAll() {
      if (this.isAll) {
        this.courseIdList = [];
      } else {
        this.courseIdList = this.tableData.map(i => i.courseId);
      }
    },
    isCheck(id) {
      console.log(id);
      return this.courseIdList.includes(id);
    },
    select(res) {
      console.log(res);
      this.courseIdList = res.map(i => i.courseId);
    },
    confirm() {
      if (!this.canEdit) {
        this.showModal = false;
        return;
      }
      this.$http({
        url: `/buz/testCenter/edit/course`,
        type: 'POST',
        data: {
          testId: this.id,
          courseIdList: this.courseIdList
        },
        apiPermissionCode: ''
      })
        .then(res => {
          this.$notice.success('操作成功');
          this.showModal = false;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    check(courseId) {
      if (this.courseIdList.includes(courseId)) {
        let idx = this.courseIdList.findIndex(i => i == courseId);
        this.courseIdList.splice(idx, 1);
      } else {
        this.courseIdList.push(courseId);
      }
    },
    sel(arr) {
      this.searchAjax();
    },
    openTemplateEdit() {
      this.$refs.importCourse.open(this.id, this.courseIdList);
    },
    cancel() {},
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: `/buz/testCenter/read/list/course/${this.id}`,
        type: 'POST',
        data: params
      })
        .then(res => {
          this.tableLoading = false;
          if (res.data && res.data.length) {
            this.tableData = res.data.map(item => {
              item._checked = true;
              return item;
            });
            this.courseIdList = res.data.map(item => {
              return item.courseId;
            });
          }
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    open(item) {
      this.canEdit = item.useTime ? false : true;
      this.tableData = [];
      this.courseIdList = [];
      if (item.id) {
        this.id = item.id;
        this.searchAjax();
      }
      this.showModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding-bottom: 90px !important;
}
.total {
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  b {
    color: #236dff;
    font-weight: 400;
    padding: 0 2px;
  }
}
.icon-check {
  width: 16px;
  cursor: pointer;
}
.btn-item {
  position: unset;
}

.main-panel {
  height: 30px;
  position: relative;
  margin-top: 10px;
  .search-box {
    height: 40px;
    position: relative;
  }

  .table-box {
    .key-name {
      font-weight: bold;
      font-size: 14px;
    }

    .key-id {
      font-size: 12px;
      color: #a8adb7;
    }
  }
}
</style>
